import ptBR from '../locales/pt-BR.json'

export default {
  /**
   * Retorna info sobre erros de validacoes
   * @param {string} model
   * @param {object} error
   * @returns {object}
   */
  buildErrors: (model, error) => {
    let output = {}
    let allErrors = []
    error.cause.forEach(item => {
      if (!output[item.target]) {
        output[item.target] = []
      }
      const message = ptBR[`validations.${model}.${item.target}.${item.rule.name}`]
      output[item.target].push(message)
      allErrors.push(message)
    })
    return {
      success: false,
      message: allErrors.join(', '),
      errors: output
    }
  },

  /**
   * Ignora campos da valdiacao
   * @param {object} schema
   * @param {string[]} fields
   * @returns {object}
   */
  ignoreFields: (schema, fields) => {
    let output = {}
    // eslint-disable-next-line
    for (let field in schema) {
      if (!fields.includes(field)) {
        output[field] = schema[field]
      }
    }
    return output
  }
}
